import { useLanguage } from "../../../../contexts/LanguageContext"

/**
 * Contextual help preview component.
 * Renders the contextual help interface with help button and background styling.
 * @returns {JSX.Element}
 */
export default function PreviewHelp() {
  const { t } = useLanguage()

  return (
    <>
      <div className="preview_headerBloc">{t("ContextualHelp.contextualHelpTitle")}</div>
      <div className="centered-flex">
        <div id="preview_contextualHelp" data-testid="preview_contextualHelp" className="shortwaysInlineHelpContainer">
          <div className="easyPreviewHelpBg" data-testid="easyPreviewHelpBg">
            <div className="shortwaysHelpButton" data-testid="shortwaysHelpButton"></div>
          </div>
        </div>
      </div>
    </>
  )
}
